export default class ClubsUserModel {
  id_clube: string | null;
  prefix: string | null;
  nome_clube: string | null;

  constructor(
    id_clube: string | null,
    prefix: string | null,
    nome_clube: string | null
  ) {
    this.id_clube = id_clube;
    this.prefix = prefix;
    this.nome_clube = nome_clube;
  }

  static fromApiResponse(data: any): ClubsUserModel {
    return new ClubsUserModel(
      data.id_clube || null,
      data.prefix || null,
      data.nome_clube || null,
    );
  }

  static fromApiResponseArray(dataArray: any[]): ClubsUserModel[] {
    return dataArray.map((data) => ClubsUserModel.fromApiResponse(data));
  }
}
